(function () {
  let productIndexPromise = null;

  function text(value) {
    return String(value == null ? '' : value);
  }

  function escapeHtml(value) {
    return text(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function engine() {
    return window.RegistaSearchEngine || null;
  }

  async function loadProductIndex(url) {
    if (!productIndexPromise) {
      productIndexPromise = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Product index failed');
          return response.json();
        })
        .then(function (data) {
          const products = Array.isArray(data.products) ? data.products : [];
          const searchEngine = engine();
          return searchEngine ? searchEngine.prepareProducts(products) : products;
        })
        .catch(function (error) {
          productIndexPromise = null;
          throw error;
        });
    }
    return productIndexPromise;
  }

  function renderIntent(root, intent) {
    const wrap = root.querySelector('[data-rls-intent]');
    const searchEngine = engine();
    if (!wrap || !searchEngine) return;
    const chips = searchEngine.intentChips(intent);
    wrap.innerHTML = '';
    wrap.classList.toggle('is-active', chips.length > 1 || Boolean(intent.size || intent.season || intent.decade || intent.type || intent.sleeve));
    if (!wrap.classList.contains('is-active')) return;

    const label = document.createElement('span');
    label.className = 'regista-live-search-intent-label';
    label.textContent = 'Understood:';
    wrap.appendChild(label);

    chips.forEach(function (chip) {
      const item = document.createElement('span');
      item.className = 'regista-live-search-intent-chip';
      item.textContent = chip;
      wrap.appendChild(item);
    });
  }

  function renderSuggestions(root, suggestions, intent) {
    const wrap = root.querySelector('[data-rls-suggestions]');
    const input = root.querySelector('[data-rls-input]');
    const searchEngine = engine();
    if (!wrap) return;

    wrap.innerHTML = '';
    suggestions.forEach(function (suggestion) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'regista-live-search-suggestion';
      button.innerHTML = '<span>' + escapeHtml(suggestion.label) + '</span><small>' + escapeHtml(suggestion.type) + '</small>';
      button.addEventListener('click', function () {
        if (!input) return;
        input.value = searchEngine ? searchEngine.queryWithFilters(suggestion.label, intent) : suggestion.label;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      wrap.appendChild(button);
    });
  }

  function productMeta(result) {
    const searchEngine = engine();
    const product = result.product;
    const parts = [];
    const team = product.tmh || product.tm;
    const player = product.hrh || product.hr;
    const country = product.coh || product.co;

    if (team) parts.push(team);
    if (player) parts.push(player);
    else if (country && country !== team) parts.push(country);

    if (result.selectedSize) {
      parts.push('Size ' + result.selectedSize);
    } else if (searchEngine) {
      const sizes = searchEngine.availableSizes(product);
      if (sizes.length) parts.push('Sizes: ' + sizes.slice(0, 6).join(', '));
    }
    return parts.slice(0, 3);
  }

  function renderProducts(root, results) {
    const wrap = root.querySelector('[data-rls-results]');
    if (!wrap) return;

    wrap.innerHTML = '';
    results.forEach(function (result) {
      const product = result.product;
      const title = product.e || product.t || '';
      const meta = productMeta(result).map(function (item) { return '<span>' + escapeHtml(item) + '</span>'; }).join('');
      const image = product.i ? '<img src="' + escapeHtml(product.i) + '" alt="' + escapeHtml(title) + '" loading="lazy" decoding="async" width="78" height="78">' : '';
      const handle = result.handle || product.h;
      const url = '/products/' + encodeURIComponent(handle);

      const item = document.createElement('a');
      item.className = 'regista-live-search-item';
      item.href = url;
      item.innerHTML =
        '<div class="regista-live-search-item-image">' + image + '</div>' +
        '<div class="regista-live-search-item-info">' +
          '<h3 class="regista-live-search-item-title" dir="ltr"><span dir="ltr">' + escapeHtml(title) + '</span></h3>' +
          '<div class="regista-live-search-item-meta">' + meta + '</div>' +
        '</div>' +
        '<span class="regista-live-search-item-action">View</span>';
      wrap.appendChild(item);
    });
  }

  function setPanel(root, open) {
    const panel = root.querySelector('[data-rls-panel]');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    const input = root.querySelector('[data-rls-input]');
    if (input) input.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function debounce(callback, wait) {
    let timeout = null;
    return function () {
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () { callback.apply(null, args); }, wait);
    };
  }

  function initSearch(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const sectionId = root.getAttribute('data-section-id') || '';
    const config = window.RegistaLiveSearchConfig && window.RegistaLiveSearchConfig[sectionId] ? window.RegistaLiveSearchConfig[sectionId] : {};
    const input = root.querySelector('[data-rls-input]');
    const clear = root.querySelector('[data-rls-clear]');
    const loading = root.querySelector('[data-rls-loading]');
    const empty = root.querySelector('[data-rls-empty]');
    const allLink = root.querySelector('[data-rls-all]');

    if (!input) return;

    if (config.preloadIndex) {
      const preload = function () {
        loadProductIndex(config.productIndexUrl || '/assets/regista-product-index.json').catch(function () {});
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 1400 });
      else setTimeout(preload, 450);
    }

    async function runSearch() {
      const query = input.value.trim();
      const minChars = Number(config.minChars || 2);
      const productLimit = Number(config.productLimit || 8);
      const suggestionLimit = Number(config.suggestionLimit || 6);
      const searchEngine = engine();

      if (clear) clear.classList.toggle('is-active', Boolean(query));

      if (query.length < minChars || !searchEngine) {
        setPanel(root, false);
        return;
      }

      setPanel(root, true);
      if (loading) loading.classList.add('is-active');
      if (empty) empty.classList.remove('is-active');
      if (allLink) allLink.hidden = true;

      try {
        const products = await loadProductIndex(config.productIndexUrl || '/assets/regista-product-index.json');
        const searchResult = searchEngine.search(products, query, {
          limit: productLimit,
          preferShirts: true
        });
        const suggestions = searchEngine.suggestions(products, query, suggestionLimit);

        renderIntent(root, searchResult.intent);
        renderSuggestions(root, suggestions, searchResult.intent);
        renderProducts(root, searchResult.results);

        if (loading) loading.classList.remove('is-active');
        if (empty) empty.classList.toggle('is-active', !suggestions.length && !searchResult.results.length);

        if (allLink) {
          allLink.href = '/search?q=' + encodeURIComponent(query);
          allLink.hidden = !searchResult.results.length;
          allLink.textContent = 'View all smart matches';
        }
      } catch (error) {
        if (loading) loading.classList.remove('is-active');
        if (empty) empty.classList.add('is-active');
      }
    }

    const debouncedSearch = debounce(runSearch, 110);
    input.addEventListener('input', debouncedSearch);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= Number(config.minChars || 2)) runSearch();
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setPanel(root, false);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        clear.classList.remove('is-active');
        const intentWrap = root.querySelector('[data-rls-intent]');
        if (intentWrap) intentWrap.innerHTML = '';
        setPanel(root, false);
        input.focus();
      });
    }

    const outsideClickHandler = function (event) {
      if (!root.contains(event.target)) setPanel(root, false);
    };
    root.__registaLiveSearchOutsideClick = outsideClickHandler;
    document.addEventListener('click', outsideClickHandler);
  }

  function smartSearchCard(result) {
    const product = result.product;
    const title = product.e || product.t || '';
    const meta = productMeta(result);
    const handle = result.handle || product.h;
    const article = document.createElement('article');
    article.className = 'regista-smart-search-card';
    article.innerHTML =
      '<a class="regista-smart-search-card__image" href="/products/' + encodeURIComponent(handle) + '">' +
        (product.i ? '<img src="' + escapeHtml(product.i) + '" alt="' + escapeHtml(title) + '" loading="lazy" decoding="async">' : '') +
      '</a>' +
      '<div class="regista-smart-search-card__body">' +
        '<h3><a href="/products/' + encodeURIComponent(handle) + '">' + escapeHtml(title) + '</a></h3>' +
        '<div class="regista-smart-search-card__meta">' + meta.map(function (item) { return '<span>' + escapeHtml(item) + '</span>'; }).join('') + '</div>' +
        '<a class="regista-smart-search-card__cta" href="/products/' + encodeURIComponent(handle) + '">View shirt</a>' +
      '</div>';
    return article;
  }

  async function initSmartSearchPage(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const query = root.getAttribute('data-query') || '';
    const indexUrl = root.getAttribute('data-index-url') || '/assets/regista-product-index.json';
    const searchEngine = engine();
    if (!query.trim() || !searchEngine) return;

    const loading = root.querySelector('[data-rssp-loading]');
    const content = root.querySelector('[data-rssp-content]');
    const grid = root.querySelector('[data-rssp-results]');
    const intentWrap = root.querySelector('[data-rssp-intent]');
    const nativeCount = Number(root.getAttribute('data-native-count') || 0);

    if (loading) loading.hidden = false;

    try {
      const products = await loadProductIndex(indexUrl);
      const found = searchEngine.search(products, query, { limit: 12, preferShirts: true });
      if (!found.results.length) {
        root.hidden = true;
        return;
      }

      if (intentWrap) {
        const chips = searchEngine.intentChips(found.intent);
        intentWrap.innerHTML = chips.map(function (chip) { return '<span>' + escapeHtml(chip) + '</span>'; }).join('');
      }

      if (grid) {
        grid.innerHTML = '';
        found.results.forEach(function (result) { grid.appendChild(smartSearchCard(result)); });
      }

      if (loading) loading.hidden = true;
      if (content) content.hidden = false;
      root.hidden = false;

      if (nativeCount === 0) {
        const section = root.closest('.shopify-section');
        if (section) section.classList.add('has-regista-smart-results');
      }
    } catch (error) {
      root.hidden = true;
    }
  }

  function initAll() {
    document.querySelectorAll('[data-regista-live-search]').forEach(initSearch);
    document.querySelectorAll('[data-regista-smart-search-page]').forEach(initSmartSearchPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('[data-regista-live-search]').forEach(initSearch);
    event.target.querySelectorAll('[data-regista-smart-search-page]').forEach(initSmartSearchPage);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('[data-regista-live-search]').forEach(function (root) {
      if (root.__registaLiveSearchOutsideClick) {
        document.removeEventListener('click', root.__registaLiveSearchOutsideClick);
        delete root.__registaLiveSearchOutsideClick;
      }
    });
  });
})();
